import { OpWiseSummaryQtyModel } from "./op-wise-summary-qty.model";

export class OpCategoryWiseSummaryQtyModel {
    opCategory: string;
    wipQty: number;
    inTransit: number;
    totalWorkingHours: number;
    opWiseSummaryQtys: OpWiseSummaryQtyModel[];
  
    constructor(
      opCategory: string,
      wipQty: number,
      inTransit: number,
      totalWorkingHours: number,
      opWiseSummaryQtys: OpWiseSummaryQtyModel[]
    ) {
      this.opCategory = opCategory;
      this.wipQty = wipQty;
      this.inTransit = inTransit;
      this.totalWorkingHours = totalWorkingHours;
      this.opWiseSummaryQtys = opWiseSummaryQtys;
    }
  }